import { RequireAuth } from '@/features/auth'
import ProjectList from '../components/ProjectList'
import DashboardLayout from './DashboardLayout'

const DashboardPage = () => {
    return (
        <DashboardLayout>
            <ProjectList />
        </DashboardLayout>
    )
}

export default DashboardPage
